import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  placeholder: 'Ref # or Card #',
  ariaLabel: 'Search transactions',
})
